export default "__VITE_PUBLIC_ASSET__b121c2f7__"